/**
 * PDP Accordion Functionality
 * Handles accordion open/close behavior and custom dropdown for variant swatches
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDPAccordion);
  } else {
    initPDPAccordion();
  }

  function initPDPAccordion() {
    initAccordions();
    initCustomDropdowns();
    initShareToggle();
  }

  /**
   * Initialize Accordion Functionality
   */
  function initAccordions() {
    var accordionHeaders = document.querySelectorAll('.pdp-accordion__header');
    
    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function(e) {
        e.preventDefault();
        var item = this.closest('.pdp-accordion__item');
        
        if (!item) return;
        
        var isActive = item.classList.contains('is-active');
        
        // Close all other accordions in the same container (optional - remove for independent behavior)
        var container = item.closest('.pdp-accordion');
        if (container) {
          var allItems = container.querySelectorAll('.pdp-accordion__item');
          allItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('is-active');
            }
          });
        }
        
        // Toggle current accordion
        if (isActive) {
          item.classList.remove('is-active');
        } else {
          item.classList.add('is-active');
        }
      });
      
      // Keyboard accessibility
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /**
   * Initialize Custom Dropdown for Metal/Color Swatches
   */
  function initCustomDropdowns() {
    var customDropdowns = document.querySelectorAll('.custom-dropdown');
    
    customDropdowns.forEach(function(dropdown) {
      var trigger = dropdown.querySelector('.custom-dropdown__trigger');
      var options = dropdown.querySelectorAll('.custom-dropdown__option');
      var nativeSelect = dropdown.querySelector('.custom-dropdown__native');
      var selectedText = dropdown.querySelector('.custom-dropdown__text');
      var selectedSwatch = dropdown.querySelector('.custom-dropdown__swatch');
      
      if (!trigger) return;
      
      // Toggle dropdown
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Close all other dropdowns
        document.querySelectorAll('.custom-dropdown.is-open').forEach(function(other) {
          if (other !== dropdown) {
            other.classList.remove('is-open');
          }
        });
        
        dropdown.classList.toggle('is-open');
      });
      
      // Handle option selection
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var value = this.getAttribute('data-value');
          var text = this.querySelector('.custom-dropdown__option-text').textContent;
          var swatchEl = this.querySelector('.custom-dropdown__option-swatch');
          var swatchColor = swatchEl ? swatchEl.style.backgroundColor : '';
          var swatchImage = swatchEl ? swatchEl.getAttribute('data-img') : '';
          
          // Update selected display
          if (selectedText) {
            selectedText.textContent = text;
          }
          
          if (selectedSwatch) {
            if (swatchColor) {
              selectedSwatch.style.backgroundColor = swatchColor;
            }
            if (swatchImage) {
              selectedSwatch.style.backgroundImage = 'url(' + swatchImage + ')';
              selectedSwatch.style.backgroundSize = 'cover';
            }
          }
          
          // Update native select for form submission
          if (nativeSelect) {
            nativeSelect.value = value;
            
            // Trigger change event for any listeners
            var changeEvent = new Event('change', { bubbles: true });
            nativeSelect.dispatchEvent(changeEvent);
          }
          
          // Update selected state
          options.forEach(function(opt) {
            opt.classList.remove('is-selected');
          });
          this.classList.add('is-selected');
          
          // Close dropdown
          dropdown.classList.remove('is-open');
          
          // Trigger variant change if using Shopify's variant selector system
          triggerVariantChange(value, dropdown);
        });
      });
      
      // Keyboard accessibility for trigger
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        } else if (e.key === 'Escape') {
          dropdown.classList.remove('is-open');
        }
      });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.custom-dropdown')) {
        document.querySelectorAll('.custom-dropdown.is-open').forEach(function(dropdown) {
          dropdown.classList.remove('is-open');
        });
      }
    });
    
    // Close dropdowns on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.custom-dropdown.is-open').forEach(function(dropdown) {
          dropdown.classList.remove('is-open');
        });
      }
    });
  }

  /**
   * Trigger variant change to sync with Shopify's variant system
   */
  function triggerVariantChange(value, dropdown) {
    var dataIndex = dropdown.getAttribute('data-option-index');
    
    if (dataIndex) {
      // Find the corresponding hidden radio/select and update it
      var hiddenInput = document.querySelector(
        '.single-option-selector[data-index="' + dataIndex + '"]'
      );
      
      if (hiddenInput) {
        if (hiddenInput.tagName === 'SELECT') {
          hiddenInput.value = value;
          var changeEvent = new Event('change', { bubbles: true });
          hiddenInput.dispatchEvent(changeEvent);
        } else {
          // For radio buttons, find and check the right one
          var radios = document.querySelectorAll(
            '.single-option-selector[data-index="' + dataIndex + '"]'
          );
          radios.forEach(function(radio) {
            if (radio.value === value) {
              radio.checked = true;
              var changeEvent = new Event('change', { bubbles: true });
              radio.dispatchEvent(changeEvent);
            }
          });
        }
      }
    }
    
    // Also update the underlying swatch input if it exists
    var swatchInput = dropdown.querySelector('.swatch-option__input[value="' + value + '"]');
    if (swatchInput) {
      swatchInput.checked = true;
      var changeEvent = new Event('change', { bubbles: true });
      swatchInput.dispatchEvent(changeEvent);
    }
  }

  /**
   * Initialize Share Button Toggle
   */
  function initShareToggle() {
    var shareContainers = document.querySelectorAll('.product-social-share-bottom');
    
    shareContainers.forEach(function(container) {
      var trigger = container.querySelector('.trigger-social');
      
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          container.classList.add('is-active');
        });
      }
    });
  }

  // Expose init function globally for dynamic content
  window.initPDPAccordion = initPDPAccordion;
  
})();